import {Component, OnDestroy} from '@angular/core';
import {Router} from '@angular/router';
import {Subject} from 'rxjs';
import {Complement} from 'src/app/models/application/complement.model';
import {PaymentData} from 'src/app/models/application/payment-data.model';
import {DialogService} from 'src/app/services/dialog.service';
import {SessionService} from 'src/app/services/session.service';
import {DeviceDetectorService} from 'ngx-device-detector';
import {Constants, redirectToLink} from '../../../common/constants';

@Component({
    selector: 'app-purchase-summary',
    templateUrl: './purchase-summary.component.html',
    styleUrls: ['./purchase-summary.component.scss']
})
export class PurchaseSummaryComponent implements OnDestroy {
    data: PaymentData;
    userData: any;
    billingData: any;
    products: PaymentData[] = [];
    itemsInCart: number;
    private ngUnsubscribe: Subject<any> = new Subject<any>();
    complementsAdd = false;
    /* VARIABLES PARA SABER SI SON MOVILES */
    isMobile: any = false;
    isTablet: any = false;
    infoLogin: any;
    countryVisit: any = false;

    constructor(
        private sessionService: SessionService,
        private dialogService: DialogService,
        private router: Router,
        private deviceService: DeviceDetectorService
    ) {
        this.isMobile = this.deviceService.isMobile();
        this.isTablet = this.deviceService.isTablet();
        this.data = this.sessionService.getPaymentData();
        this.userData = this.sessionService.getPaymentAccount();
        this.infoLogin = this.sessionService.getAuthData();
        this.billingData = this.sessionService.getPaymentBilling();
        this.products = this.sessionService.getCartItems();
        this.sessionService.genPaymentSteps();
        if (!this.userData || this.products.length === 0) {
            this.dialogService.showNotificationDialog('Informação não disponível', 'Não há informações de compra');
            this.router.navigate(['/']);
        }
        if (this.products.length !== 0) {
            this.addDataLayerPago();
            this.addDataLayer();
            this.sessionService.clearCartItems();
            this.sessionService.setDataPay('');
            this.sessionService.setPaymentBilling('');
        }
        window.scrollTo(0, 0);
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
        if (this.sessionService.getAccountData()) {
            sessionStorage.clear();
        }
    }

    getTotalIVA(total: any): any {
        if (this.getTotalDescuento() && this.countryVisit) {
            const totalDescuento: number = Number(parseFloat(this.getTotalDescuento()).toFixed(2)) +
                Number(parseFloat(String(this.getTotalDescuento() * .16)).toFixed(2));
            return totalDescuento.toFixed(2);
        }
        return parseFloat(total).toFixed(2);
    }

    getTransacciones(data: PaymentData): string {
        switch (data.type) {
            case 'month':
                return ' Assinaturas ilimitadas ';
            case 'anual':
                return data.transactions + ' Assinaturas ';
        }
    }

    getPriceCentavos(price: number): any {
        return parseFloat(price.toString()).toFixed(2);
    }

    getTotalDescuento(): any {
        if (this.sessionService.getPromoCode()) {
            return parseFloat(String(this.sessionService.getPromoCode().amounts[0].amountAfterDiscount / 100)).toFixed(2);
        }
        return null;
    }

    getTotal(aux?: number): any {
        let total = 0;
        let aux1 = 0;
        this.itemsInCart = 0;
        const items = this.products;
        items.forEach((data: PaymentData) => {
            total += data.quantity * data.pricing;
            this.itemsInCart += data.quantity;
            data.complements.forEach((dataComplement: Complement) => {
                if (dataComplement.isAdd) {
                    total += dataComplement.price * dataComplement.quantity;
                    aux1++;
                }
                if (aux === 0) {
                    this.complementsAdd = false;
                } else if (aux >= 1) {
                    this.complementsAdd = true;
                }
            });
        });
        if (aux === 1 && this.countryVisit) {
            total = Number.parseFloat(total.toString()) + Number.parseFloat(this.getIVA(total * 0.16));
        }
        return parseFloat(total.toString()).toFixed(2);
    }

    getIVA(total: any): any {
        return parseFloat(total).toFixed(2);
    }

    openLink(link): void {
        this.router.navigate(['/']);
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
        redirectToLink(link);
    }

    goToBackOffice(): void {
        window.open(Constants.BACKOFFICE_URL
            + this.sessionService.getEncryptedData(this.infoLogin.access_token,
                Constants.configSession.userP), '_self');
    }

    addDataLayerPago(): any {
        // @ts-ignore
        window.dataLayer = window.dataLayer || [];
        // @ts-ignore
        dataLayer.push({ecommerce: null});
        // @ts-ignore
        dataLayer.push({
            event: 'transaction',
            ecommerce: {
                purchase: {
                    actionField: {
                        id: 'FM' + Math.floor((Math.random() * (1000 - 1 + 1)) + 1) + 'CC'
                            + Math.floor((Math.random() * (1000 - 1 + 1)) + 1),
                        affiliation: 'Online Store',
                        revenue: this.getTotalDescuento() === null ? this.getTotalIVA(this.getTotal(0))
                            : this.getTotalIVA(this.getTotalDescuento()),
                        tax: 0,
                        transaction_id: 'FM' + Math.floor((Math.random() * (1000 - 1 + 1)) + 1) + 'CC'
                            + Math.floor((Math.random() * (1000 - 1 + 1)) + 1),
                        value: this.getTotalDescuento() === null ? this.getTotalIVA(this.getTotal(0))
                            : this.getTotalIVA(this.getTotalDescuento()),
                        transactionTotal: this.getTotalDescuento() === null ? this.getTotalIVA(this.getTotal(0))
                            : this.getTotalIVA(this.getTotalDescuento()),
                    },
                    products: [
                        {
                            name: this.products[0].product === 'FAD® EMPRESARIAL' ?
                                'FAD® - Plano Empresarial - Plano Mensal' : this.products[0].type === 'month' ?
                                    'FAD® - Plano Pessoal - Plano Mensal' : 'FAD® - Plano Pessoal - Pré-pago anual',
                            id: this.products[0].product === 'FAD® EMPRESARIAL' ?
                                'FADPESM' : this.products[0].type === 'month' ? 'FADPPSM' : 'FADPPPA' + this.products[0].transactions,
                            price: this.products[0].pricing,
                            brand: 'FAD®',
                            category: this.products[0].product === 'FAD® EMPRESARIAL' ?
                                'FAD® Empresarial' : 'FAD® Pessoal',
                            variant: this.products[0].product === 'FAD® EMPRESARIAL' ?
                                'Assinaturas Ilimitadas' : this.products[0].type === 'month' ?
                                    'Assinaturas Ilimitadas' : 'Anual ' + this.products[0].transactions,
                            quantity: 1,
                        }
                    ]
                }
            }
        });
    }

    addDataLayer(): any {
        // @ts-ignore
        window.dataLayer = window.dataLayer || [];
        // @ts-ignore
        dataLayer.push({ecommerce: null});  // Clear the previous ecommerce object.
        // @ts-ignore
        dataLayer.push({
            event: 'checkout',
            ecommerce: {
                checkout: {
                    actionField: {step: 5, option: 'Compra Finalizada'},
                }
            }
        });
    }

}
